import usePagination from '@/hooks/usePagination';
import { GroupsFilters, SortType } from '@/types/schema';

import { useGroupsQuery } from '../graphql/queries/generated/groups';

function useGroups({
  sort,
  filters,
  pause,
}: {
  sort?: SortType[];
  filters?: GroupsFilters;
  pause?: boolean;
}) {
  const { data, isFetchingMore, error, refetch, fetchMore, isFetching, isLoading, totalCount } =
    usePagination(
      useGroupsQuery,
      {
        filters,
        sort,
      },
      {
        edgeKey: 'groups',
        requestPolicy: 'cache-and-network',
        pause,
      },
    );

  return {
    isFetching,
    isFetchingMore,
    isLoading,
    error,
    groups: data,
    totalCount,
    refetch,
    fetchMore,
  };
}

export default useGroups;
